<template>
  <section class="auth-section login h-100">
    <div class="container-fluid h-100">
      <div class="row align-items-center h-100">
        <div v-if="lightMood === true" class="col-sm-6 crop1">
          <img
            src="../../../assets/images/LoginPageLightMood.png"
            class="img-fluid logoLarge"
          />
        </div>
        <div class="col-sm-6 crop2" v-else>
          <img
            src="../../../assets/images/auth-img.svg"
            class="img-fluid logoLarge"
          />
        </div>
        <div v-if="lightMood === true" class="col-sm-6">
          <div class="auth-form form-width">
            <div class="imageInLoginLightMood text-center">
              <img
                src="../../../assets/images/LogoLightMood.svg"
                width="200"
                class="img-fluid logoLarge"
              />
            </div>
            <form id="informed-form" @submit.prevent="login" class="login-form">
              <div class="row">
                <div class="col-12">
                  <div class="form-group">
                    <h4 class="form-title">Login</h4>
                  </div>
                </div>
                <div class="col-12 pt-5">
                  <div v-if="errorMessage" class="err text-danger">
                    *{{ errorMessage }}
                  </div>
                  <div class="form-group">
                    <label for="email"
                      >Email<span class="text-danger">*</span></label
                    >
                    <input
                      type="email"
                      v-bind:class="{ 'border-danger': emailError }"
                      class="form-control"
                      v-model="user.email"
                      id="email"
                      name="email"
                      placeholder="Email@example.com"
                      @input="emailHandler"
                    />
                    <div v-if="emailError" class="err text-danger">
                      *{{ emailError }}
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <div class="form-group">
                    <label for="password"
                      >Password <span class="text-danger">*</span></label
                    >
                    <input
                      v-if="isActive === false"
                      type="password"
                      v-bind:class="{ 'border-danger': passwordError }"
                      class="form-control"
                      v-model="user.password"
                      id="password"
                      name="password"
                      placeholder="Password"
                      @input="passwordHandler"
                    />
                    <input
                      v-if="isActive === true"
                      type="text"
                      class="form-control"
                      v-model="user.password"
                      id="password"
                      name="password"
                      placeholder="Password"
                    />
                    <span
                      v-if="isActive === false"
                      class="p-viewer"
                      @click="toggle"
                    >
                      <font-awesome-icon
                        :icon="['fas', 'eye']"
                        id="togglePassword"
                        size="lg"
                      />
                    </span>
                    <span
                      v-if="isActive === true"
                      class="p-viewer"
                      @click="toggle"
                    >
                      <font-awesome-icon
                        :icon="['fas', 'eye-slash']"
                        id="togglePassword"
                        size="lg"
                      />
                    </span>

                    <div v-if="passwordError" class="err text-danger">
                      *{{ passwordError }}
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <div class="row p-sm-2">
                    <div class="col-sm-6">
                      <div class="form-check checkbox">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          v-model="user.remember_me"
                          id="gridCheck1"
                        />
                        <label class="form-check-label" for="gridCheck1">
                          Remember me
                        </label>
                      </div>
                    </div>
                    <div class="col-6 d-flex justify-content-end">
                      <router-link :to="'/forget-password'">
                        <a href="#" class="auth-links">Forgot password?</a>
                      </router-link>
                    </div>
                  </div>
                </div>

                <div class="col-12">
                  <div class="form-group">
                    <div class="">
                      <button type="submit" class="btn auth-button" id="submit">
                        Login
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div v-else class="col-sm-6">
          <div class="auth-form form-width">
            <form id="informed-form" @submit.prevent="login" class="login-form">
              <div class="row">
                <div class="col-12">
                  <div class="form-group">
                    <h4 class="form-title">Login</h4>
                  </div>
                </div>
                <div class="col-12 pt-5">
                  <div v-if="errorMessage" class="err text-danger">
                    *{{ errorMessage }}
                  </div>
                  <div class="form-group">
                    <label for="email"
                      >Email<span class="text-danger">*</span></label
                    >
                    <input
                      type="email"
                      v-bind:class="{ 'border-danger': emailError }"
                      class="form-control"
                      v-model="user.email"
                      id="email"
                      name="email"
                      placeholder="Email@example.com"
                      @input="emailHandler"
                    />
                    <div v-if="emailError" class="err text-danger">
                      *{{ emailError }}
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <div class="form-group">
                    <label for="password"
                      >Password<span class="text-danger">*</span></label
                    >
                    <input
                      v-if="isActive === false"
                      type="password"
                      v-bind:class="{ 'border-danger': passwordError }"
                      class="form-control"
                      v-model="user.password"
                      id="password"
                      name="password"
                      placeholder="Password"
                      @input="passwordHandler"
                    />
                    <input
                      v-if="isActive === true"
                      type="text"
                      class="form-control"
                      v-model="user.password"
                      id="password"
                      name="password"
                      placeholder="Password"
                    />
                    <!-- <span
                      v-if="isActive === false"
                      class="p-viewer"
                      @click="toggle"
                    >
                      <font-awesome-icon
                        :icon="['fas', 'eye']"
                        id="togglePassword"
                        size="lg"
                      />
                    </span>
                    <span
                      v-if="isActive === true"
                      class="p-viewer"
                      @click="toggle"
                    >
                      <font-awesome-icon
                        :icon="['fas', 'eye-slash']"
                        id="togglePassword"
                        size="lg"
                      />
                    </span> -->

                    <div v-if="passwordError" class="err text-danger">
                      *{{ passwordError }}
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <div class="row p-sm-2">
                    <div class="col-sm-6">
                      <div class="form-check checkbox">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          v-model="user.remember_me"
                          id="gridCheck1"
                        />
                        <label class="form-check-label" for="gridCheck1">
                          Remember me
                        </label>
                      </div>
                    </div>
                    <!-- <div class="col-6 d-flex justify-content-end">
                      <router-link :to="'/forget-password'">
                        <a href="#" class="auth-links">Forgot password?</a>
                      </router-link>
                    </div> -->
                  </div>
                </div>

                <div class="col-12">
                  <div class="form-group">
                    <div class="">
                      <button type="submit" class="btn auth-button" id="submit">
                        LOGIN
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "login-page",
  data() {
    return {
      user: {
        email: null,
        password: null,
        remember_me: false,
      },
      lightMood: null,
      error: null,
      userRoles: [],
      permissions: [],
      errorMessage: "",
      passwordError: "",
      emailError: "",
      errorModal: false,
      isActive: false,
      entitiesCount: 0,
      usersCount: 0,
      urls: [
        "template",
        "competition",
        "training",
        "userscore",
        "setting",
        "entity",
      ],
      routes: {
        template: "templates",
        competition: "competitions",
        training: "trainings",
        userscore: "results",
        setting: "settings/roles",
        entity: "settings/entities",
      },
    };
  },
  mounted() {
    this.lightMood = this.$store.state.settings.isLightMood;
    const searchParams = new URLSearchParams(window.location.search);
    
  },
  computed: {
    lightMood() {
      return this.$store.state.settings.isLightMood;
    },
  },
  methods: {
    passwordHandler(e) {
      this.passwordError = e.target.value.length > 0 ? "" : "required";
    },
    emailHandler(e) {
      this.emailError = e.target.value.length > 0 ? "" : "required";
    },
    async login() {
      this.error = null;
      this.errorMessage = "";
      this.passwordError = "";
      this.emailError = "";
      let url = "";

      try {
        if (this.user.email && this.user.password) {
          await this.$store.dispatch("login", this.user);
          this.userRoles = (await this.$store.state?.auth?.user)
            ? this.$store.state?.auth?.user.data.role
            : null;
          this.permissions = (await this.$store.state?.auth?.user)
            ? this.$store.state.auth.permissions
            : null;

          if (this.userRoles.length > 0) {
            if (this.permissions.includes("viewAny organization")) {
              url = "/organizations";
            } else if (this.userRoles.includes("user")) {
              url = "/user-competitions";
            } else if (
              this.permissions.includes("create template") ||
              this.permissions.includes("update template") ||
              this.permissions.includes("delete template") ||
              this.permissions.includes("viewAny template") ||
              this.permissions.includes("create competition") ||
              this.permissions.includes("update competition") ||
              this.permissions.includes("delete competition") ||
              this.permissions.includes("viewAny competition") ||
              this.permissions.includes("create training") ||
              this.permissions.includes("update training") ||
              this.permissions.includes("delete training") ||
              this.permissions.includes("viewAny training") ||
              this.permissions.includes("read template") ||
              this.permissions.includes("viewAny setting") ||
              this.permissions.includes("read userscore") ||
              this.permissions.includes("viewAny userscore") ||
              this.permissions.includes("create userscore") ||
              this.permissions.includes("create entity") ||
              this.permissions.includes("update entity") ||
              this.permissions.includes("delete entity") ||
              this.permissions.includes("viewAny entity") ||
              this.permissions.includes("create role") ||
              this.permissions.includes("update role") ||
              this.permissions.includes("delete role") ||
              this.permissions.includes("viewAny role") ||
              this.permissions.includes("create user") ||
              this.permissions.includes("update user") ||
              this.permissions.includes("delete user") ||
              this.permissions.includes("viewAny user") ||
              this.permissions.includes("create team") ||
              this.permissions.includes("update team") ||
              this.permissions.includes("delete team") ||
              this.permissions.includes("viewAny team")
            ) {
              // this.entitiesCount = await this.$store.state?.auth?.user ?
              //     (this.$store.state?.auth?.user.data.organization !== undefined ? (this.$store.state?.auth?.user.data.organization?.entities ): '' ) : 0;
              //
              // this.usersCount = await this.$store.state?.auth?.user ? this.$store.state?.auth?.user.data.users.length : 0;

              url = "/";

              for (let idx = 0; idx < this.urls.length; idx++) {
                if (this.permissions.includes("viewAny " + this.urls[idx])) {
                  url = "/" + this.routes[this.urls[idx]];
                  break;
                }
              }
              // if (this.entitiesCount === 0) {
              //     url = '/settings/entities';
              // } else if (this.usersCount === 0) {
              //     url = '/settings';
              // } else {
              //     url = '/templates';
              // }
            } else {
              url = "/";
            }
            await this.$store.dispatch("setAnswersFlag", false);
            await this.$store.dispatch("setDataFlag", false);
            await this.$router.push({ path: url });
          }
        } else {
          if (!this.user.email) this.emailError = "required";
          if (!this.user.password) this.passwordError = "required";
        }
      } catch (e) {
        console.log(e);
        this.error = e;
        this.errorMessage = e.response?.data?.message;
        if (e.response?.data?.errors?.password) {
          e.response.data?.errors?.password.forEach((err) => {
            this.passwordError += err + "\n";
          });
        }
        if (e.response.data?.errors?.email) {
          e.response.data?.errors?.email.forEach((err) => {
            this.emailError += err + "\n";
          });
        }
      }
    },
    toggle() {
      if (!this.isActive) {
        this.isActive = true;
      } else {
        this.isActive = false;
      }
    },
  },
};
</script>

<style scoped>
.auth-section {
  width: 100%;
  height: auto;
  margin: auto 0;
}

.auth-section .form-group {
  margin-bottom: 0.5rem;
  width: 100%;
  position: relative;
}

.auth-section .crop1 {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 100%;
  background-color: #012f3d;
}

.auth-section .crop1 img {
  display: block;
  width: 100%;
  margin-left: -15px;
  max-width: 750px;
}

.auth-section .crop2 {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.auth-section .crop2 img {
  display: block;
  width: 100%;
  margin-left: -15px;
  max-width: 750px;
}

.auth-section .form-light-txt {
  color: var(--main-color);
  line-height: 1.1;
}

.auth-button {
  background-color: var(--btn-bg-color);
  width: 100%;
  color: var(--btn-text-color);
  font-weight: bold;
  height: 45px;
  margin-bottom: 0.5rem;
}

.auth-button:focus,
.auth-button:hover {
  color: var(--btn-text-color);
}

.auth-section .p-viewer {
  top: 35px;
  position: absolute;
  right: 7px;
  z-index: 2;
  cursor: pointer;
  color: var(--btn-bg-color);
}

.auth-section .auth-form {
  background-image: linear-gradient(
    var(--secondary-bg1-color),
    var(--secondary-bg2-color)
  );
  border: 1px solid var(--table-border);
  box-shadow: 5px 11px 113px -14px rgba(0, 0, 0, 0.21) inset;
  -webkit-box-shadow: 5px 11px 113px -14px rgba(0, 0, 0, 0.21) inset;
  -moz-box-shadow: 5px 11px 113px -14px rgba(0, 0, 0, 0.21) inset;
  border-radius: 10px;
  padding: 3rem;
  min-height: 63vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.auth-section.register .auth-form {
  min-height: 100vh;
}

.auth-section .auth-links {
  margin-left: auto;
  color: var(--main-color);
  text-decoration: underline;
}

.auth-section .auth-links:hover {
  color: var(--main-color);
}

.auth-section .form-group input,
.auth-section select {
  height: 45px !important;
  background-color: transparent;
  color: var(--main-color);
}

.auth-section span.error {
  color: #e95626;
  font-size: 14px;
}

.auth-section .error::before {
  content: "* ";
}

.auth-section form {
  color: var(--main-color);
}

.auth-section input[type="checkbox"] {
  -ms-transform: scale(1.3); /* IE */
  -moz-transform: scale(1.3); /* FF */
  -webkit-transform: scale(1.3); /* Safari and Chrome */
  -o-transform: scale(1.3); /* Opera */
  transform: scale(1.3);
  padding: 10px;
}

.auth-section .center {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

.auth-section .bootstrap-tagsinput {
  background-color: #fff;
  border: 1px solid #ccc;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  display: block;
  padding: 4px 6px;
  color: #555;
  vertical-align: middle;
  border-radius: 4px;
  max-width: 100%;
  line-height: 22px;
  cursor: text;
}

.auth-section .bootstrap-tagsinput input {
  border: none;
  box-shadow: none;
  outline: none;
  background-color: transparent;
  padding: 0 6px;
  margin: 0;
  width: auto;
  max-width: inherit;
}

.auth-section .form-width {
  max-width: 650px;
  margin: auto;
}

.auth-section .brand-group {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}

.auth-section .brand-group br {
  display: none;
}

.auth-section .brand-group .error {
  order: 3;
}

.auth-section input[type="checkbox"] {
  width: auto;
  opacity: 0.00000001;
  position: absolute;
  left: 0;
  margin-left: -20px;
}

.checkbox {
  width: 100%;
  position: relative;
  display: flex;
  padding-right: 0;
  margin-left: -10px;
  flex-wrap: wrap;
  padding-left: 0;
}

.checkbox input[type="checkbox"] {
  width: auto;
  opacity: 0.00000001;
  position: absolute;
  left: 0;
  margin-left: -20px;
}

.checkbox label {
  padding-top: 3px;
  min-height: 34px;
  display: flex;
  padding-left: 35px;
  margin-bottom: 0;
  font-weight: normal;
  cursor: pointer;
  vertical-align: middle;
  flex-wrap: nowrap;
  flex-grow: 1;
  position: relative;
}

.checkbox label:before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  margin: 4px;
  width: 22px;
  height: 22px;
  transition: transform 0.28s ease;
  border-radius: 3px;
  border: 2px solid var(--btn-bg-color);
}

.checkbox label:after {
  content: "";
  display: block;
  width: 10px;
  height: 5px;
  border-bottom: 2px solid #e65c00;
  border-left: 2px solid #e65c00;
  -webkit-transform: rotate(-45deg) scale(0);
  transform: rotate(-45deg) scale(0);
  transition: transform ease 0.25s;
  will-change: transform;
  position: absolute;
  top: 12px;
  left: 10px;
}

.checkbox input[type="checkbox"]:checked ~ label::before {
  color: #e65c00;
}

.checkbox input[type="checkbox"]:checked ~ label::after {
  -webkit-transform: rotate(-45deg) scale(1);
  transform: rotate(-45deg) scale(1);
}

/* media */

@media (max-height: 767px) {
  .auth-section .auth-form {
    padding: 1rem 2rem;
  }

  .auth-section .p-viewer {
    top: 50%;
  }

  .auth-section .form-group input,
  .auth-section select {
    height: 35px !important;
  }

  .select2-container .select2-selection--multiple {
    min-height: 35px !important;
  }

  .select2-container--default
    .select2-selection--multiple
    .select2-selection__choice {
    margin-top: 5px;
  }

  .select2-container .select2-search--inline .select2-search__field {
    margin-top: 5px;
  }

  span.error {
    font-size: 12px;
  }
}

@media (width: 1024px) {
  .auth-section .p-viewer {
    top: 31px;
  }
}
</style>